import { useTranslation } from 'react-i18next';

interface ContactMethodsProps {
  onChatClick: () => void;
  onFaqClick: () => void;
}

export function ContactMethods({ onChatClick, onFaqClick }: ContactMethodsProps) {
  const { t } = useTranslation();

  const handleEmailClick = () => {
    window.location.href = 'mailto:support@nutribot.com';
  };

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('support@nutribot.com');
      // Toast notification would go here
    } catch (err) {
      console.error('Failed to copy email:', err);
    }
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {/* Email Card */}
          <div className="bg-gray-800 rounded-2xl border border-gray-700 p-8 hover:scale-105 transition-transform duration-300 cursor-pointer group" onClick={handleEmailClick}>
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 flex items-center justify-center bg-yellow-400/10 rounded-full">
                <i className="ri-mail-line text-4xl text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white">{t('contact.methods.email.title')}</h3>
              <p className="text-yellow-400 font-medium group-hover:underline">{t('contact.methods.email.content')}</p>
              <p className="text-sm text-gray-400">{t('contact.methods.email.subtitle')}</p>
            </div>
          </div>

          {/* Live Chat Card */}
          {/* <div className="bg-gray-800 rounded-2xl border border-gray-700 p-8 hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={onChatClick}>
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 flex items-center justify-center bg-yellow-400/10 rounded-full">
                <i className="ri-chat-4-line text-4xl text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white">{t('contact.methods.chat.title')}</h3>
              <p className="text-gray-300">{t('contact.methods.chat.content')}</p>
              <p className="text-sm text-gray-400">{t('contact.methods.chat.subtitle')}</p>
              <button className="mt-4 px-6 py-2 bg-yellow-400 text-black rounded-lg font-medium hover:bg-yellow-500 transition-colors whitespace-nowrap">
                {t('contact.methods.chat.button')}
              </button>
            </div>
          </div> */}

          {/* FAQ Card */}
          <div className="bg-gray-800 rounded-2xl border border-gray-700 p-8 hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={onFaqClick}>
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 flex items-center justify-center bg-yellow-400/10 rounded-full">
                <i className="ri-question-line text-4xl text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white">{t('contact.methods.faq.title')}</h3>
              <p className="text-gray-300">{t('contact.methods.faq.content')}</p>
              <p className="text-sm text-gray-400">{t('contact.methods.faq.subtitle')}</p>
              <button className="mt-4 px-6 py-2 bg-gray-700 text-white rounded-lg font-medium hover:bg-gray-600 transition-colors whitespace-nowrap">
                {t('contact.methods.faq.link')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
